/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  props: {
    mode: {
      // default: () => 'aggressive'
      default: () => 'lazy'
      // default: () => undefined
    },
    vid: {},
    value: {},
    name: {
      required: true
    },
    hideTopLabel: {
      type: Boolean,
      default: () => !0
    },
    label: {
      default () {
        return undefined
      }
    },
    placeholder: {
      default () {
        return this.label
      }
    },
    rules: {
      type: [Array, String],
      default: () => undefined
    },
    errors: {
      type: Array,
      default: () => []
    },
    errorCount: {
      type: [Number, String],
      default: () => undefined
    },
    clearable: {
      type: Boolean,
      default: () => !1
    },
    readonly: {
      type: Boolean,
      default: () => !1
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    required: {
      type: Boolean,
      default: () => !1
    },
    immediate: {
      default: () => false
    },
    counter: {
      type: Boolean,
      default: () => false
    },
    forceClearable: {
      type: Boolean,
      default: () => !1
    },
    hideRequired: {
      type: Boolean,
      default: () => !1
    },
    hideDetails: {
      type: [Boolean, String],
      default: () => 'auto'
    }
  },
  computed: {
    getAutocomplete () {
      return this.$attrs?.autocomplete || this.name
    },
    getLabel () {
      const k = this.label === undefined ? this.name : this.label
      let label = ''
      if (k) {
        label = this.parseAttribute(k)
        if (label && this.hasRequired && !this.hideRequired) {
          label = `${label} *`
        }
      }
      return label
    },
    getTopLabel () {
      const label = this.getLabel
      let html = label ? label.trim() : ''
      if (label && label.slice(-1).trim() === '*') {
        html = html.slice(0, -1)
        html += '<span class="error--text">*</span>'
      }
      return html
    },
    getPlaceholder () {
      if (!this.placeholder && this.hasMobile) {
        return '05xxxxxxxx'
      }
      const k = this.placeholder === undefined ? this.name : this.placeholder
      return k ? this.parseAttribute(k) : ''
    },
    getRules () {
      let rules = this.rules || []
      rules = typeof rules === 'string' ? rules.split('|') : rules
      if (this.required === !0 && rules.indexOf('required') === -1) {
        rules.push('required')
      }
      // console.log(rules)
      return rules.join('|')
      // return 'required';
    },
    getClearable () {
      return this.forceClearable === !0 ? !0 : (this.readonly === true ? false : this.clearable)
      // return this.readonly === true || this.disabled === true ? false : this.clearable
    },
    hasRequired () {
      if (this.required === !0) return !0
      let r = this.getRules || ''
      if (typeof r === 'string') {
        r = r.split('|')
      }

      return r.indexOf('required') !== -1
    },
    hasMobile () {
      let r = this.getRules || ''
      if (typeof r === 'string') {
        r = r.split('|')
      }

      return r.indexOf('mobile') !== -1
    },
    getErrorCount () {
      return this.errorCount === undefined ? 1 : (parseInt(this.errorCount) || 1)
    },
    getErrorMessages () {
      const provider = this.$refs.provider
      let errors = [...this.errors]
      provider && (errors = [...errors, ...provider.errors])

      return errors
    },
    isEnglishName () {
      const name = (this.name || '').toLowerCase()
      // console.log(this.name, name.slice(-3, -2), name, ['_id', '_ar'].indexOf(name.slice(-3)))
      // const skipKeys = ['created_at', 'updated_at']
      const has = name.slice(-3, -2) === '_'
      if (!has) return !1
      const locale = name.slice(-2).toLocaleLowerCase()
      return this.IsAppLocale(locale) && locale !== 'ar'
      // console.log(this.IsAppLocale(locale), locale)
      // return name.slice(-3, -2) === '_' && name.slice(-3) !== '_ar' && ['_id', '_ar'].indexOf(name.slice(-3)) === -1 && skipKeys.indexOf(name) === -1
    }
  }
}
